import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Utils } from '@/tools/utils';
import './login-switch.less';

class LoginSwitch extends React.PureComponent {
    render() {
        const { location } = this.props;
        const search = location.search
        const merchantBelong = new URLSearchParams(search).get('merchantBelong');
        const query = merchantBelong ? `?merchantBelong=${merchantBelong}` : ''

        return (
            <div className='login-switch'>
                {/* <Button type="link" onClick={() => (history.push('/recoverPwd'))}>
                    忘记密码
                </Button> */}
                <Link to={`/login/recover${query}`} onClick={()=>{
                    Utils.customTrack('MerchantLoginClick', {
                        element_content: '忘记密码'
                    });
                }}>忘记密码</Link>
                {
                    location.pathname === '/login/merchant' ?

                        <Link to={`/login${query}`} onClick={()=>{
                            Utils.customTrack('MerchantLoginClick', {
                                element_content: '密码/验证码登录'
                            });
                        }}>
                            密码/验证码登录
                        </Link>
                        :
                        <Link to={`/login/merchant${query}`} onClick={()=>{
                            Utils.customTrack('MerchantLoginClick', {
                                element_content: '商户号登录'
                            });
                        }}>
                            商户号登录
                        </Link>
                        // <Button type="link" onClick={() => (history.push('/login'))}>
                        //     密码/验证码登录
                        // </Button>
                        // :
                        // <Button type="link" onClick={() => (history.push('/login/merchant'))}>
                        //     商户号登录
                        // </Button>
                }
            </div>
        );
    }
}

export default (withRouter(LoginSwitch));
